import { useRef, useState } from 'react';
import { apiService } from '../services/apiService';

export default function ManualSecondReviewButton({ frame, onUpdated }) {
    const [starting, setStarting] = useState(false);
    const [error, setError] = useState(null);
    const inFlight = useRef(false);
    const review = frame.qualification?.manual_second_review;
    const queued = ['queued', 'running'].includes(review?.status) || review?.retrying === true;
    if (!queued && review?.can_request !== true) return null;

    const request = async () => {
        if (inFlight.current || queued) return;
        inFlight.current = true;
        setStarting(true);
        setError(null);
        try {
            const result = await apiService.request('/club/frame/qualification/second-review', {
                method: 'POST', body: { id: frame.id }, skipOfflineQueue: true,
            });
            if (!result?.success || !result.frame) throw new Error(result?.message || 'Could not queue the second check.');
            onUpdated(result.frame);
        } catch (e) {
            setError(e?.message || 'Could not queue the second check. Please retry.');
        } finally {
            inFlight.current = false;
            setStarting(false);
        }
    };

    return <>
        <button type="button" className={`ai-retry-button ${starting || queued ? 'is-loading' : ''}`}
            disabled={starting || queued} aria-busy={starting || queued} onClick={request}
            title="Ask the free NVIDIA reviewer to check this frame again. The result may change its qualification.">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <path d="M20 7v5h-5M4 17v-5h5M6 7a7 7 0 0 1 12 0l2 5M4 12l2 5a7 7 0 0 0 12 0" />
            </svg>
            <span>{starting ? 'Starting…' : review?.status === 'running' ? 'Second check running…' : queued ? 'Second check queued' : review?.status === 'failed' ? 'Retry second check' : 'Run second check'}</span>
        </button>
        {error && <span className="ai-retry-error" role="alert">{error}</span>}
    </>;
}
